<template>

    <app-layout title="Dashboard" v-if="portal=='vue'">
    </app-layout>
    
    <app-layout title="Dashboard" v-if="portal=='electron'">
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'

export default {
    components: {
        AppLayout 
    },
    data(){
        return{
            portal:'',
            meta:''
        }
    },
    methods:{
        getCookie(name) {
            const value = `; ${document.cookie}`;
            return value.split(";")[1].split("=")[1];
        }
    },
    created:function(){
          this.meta=this.getCookie();
          if(this.meta == 'electron'){
              this.portal = 'electron';
          }
          else{
              this.portal = 'vue';
          }
    }
}
</script>

<style>

</style>